import * as moment from 'moment'

const passwordValidationConditions: any = {
  lowercase: /[a-z]/,
  uppercase: /[A-Z]/,
  number: /[0-9]/,
  specialCharacter: /[=+\-^$*.[\]{}()?"!@#%&/\,><':;|_~`]/,
  length: (value: string) => value.length >= 8 && 99 >= value.length,
  validCharacters: /^[a-zA-Z0-9=+\-^$*.[\]{}()?"!@#%&/\,><':;|_~`]*$/,
}

/**
 * Validate a textfield
 *
 * @param {String} value
 * The input event object
 */
const textField = (value: string): boolean => (value.length > 2 ? true : false)

/**
 * Validate an email field (very basic - checks for an @ symbol and then one fullstop)
 *
 * @param {String} value
 * The input event object
 */
const emailField = (value: string): boolean => new RegExp(/\S+@\S+\.\S+/, 'g').test(value)

/**
 * Compare two dates and make sure one is after the other
 *
 * @param {String} value
 * The input event object
 */
const compareDate = (value: any, otherValue: string): boolean => moment(value).isAfter(otherValue, 'second')

/**
 * Validate a number to have a minimum and a maximum value
 *
 * @param {String} value
 * The input event object
 */
const minMaxValue = (value: any, min: number, max: number): boolean => (min <= value && value <= max ? true : false)

/**
 * Validate an array to be at least a certain length
 *
 * @param {String} value
 * The input event object
 */
const arrLength = (value: any, min: number): boolean => value && value.length > min

/**
 * Validate two strings to be the same
 *
 * @param {String} value
 * The input event object
 */
const same = (value: string, otherValue: string): boolean => value === otherValue

/**
 * Validate a password meets the requirements
 *
 * @param {String} value
 * The input event object
 */
const password = (value: string) => {
  if (!value) return false

  return Object.keys(passwordValidationConditions).every((conditionName: any) =>
    checkPasswordCondition(value, passwordValidationConditions[conditionName])
  )
}

/**
 * A standard way to check password conditions
 * @param {String} value
 * @param condition
 */
const checkPasswordCondition = (value: string, condition: any) => {
  if (typeof condition === 'function') {
    return condition(value)
  }

  return condition.test(value)
}

export {
  textField,
  emailField,
  compareDate,
  minMaxValue,
  arrLength,
  same,
  password,
  checkPasswordCondition,
  passwordValidationConditions,
}
